import React from "react";
import informationIcon from "../../assets/img/Information.svg";

const NumberTyped = ({ answer, handleChange, error, question, name, info }) => (
  <div className="cus_form basic_question_box">
    <div className="custom_filed custom_basic">
      <div className="form-group">
        <label htmlFor={name} className="basic">
          {question}
          {info && (
            <img
              src={informationIcon}
              alt="Information"
              data-toggle="tooltip"
              data-placement="bottom"
              title={typeof info === "string" ? info : ""}
              style={{ cursor: "pointer", marginLeft: "5px" }}
            />
          )}
        </label>
        <input
          type="number"
          className="form-control"
          id={name}
          name={name}
          placeholder="Enter value"
          value={answer}
          onChange={handleChange}
        />
        {error && (
          <p className="text-danger" style={{ marginTop: "5px" }}>
            {error}
          </p>
        )}
      </div>
    </div>
  </div>
);

export default NumberTyped;
